<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 44.6 44.6" style="enable-background:new 0 0 44.6 44.6;" xml:space="preserve">
<style type="text/css">
	.st0{display:none;}
	.st1{display:inline;}
</style>
<g id="Layer_1" class="st0">
	<g id="Layer_1_copy" class="st1">
		<path d="M22.3,8.7c-2.1,0-3.9,1.7-3.9,3.9s1.7,3.9,3.9,3.9s3.9-1.7,3.9-3.9S24.4,8.7,22.3,8.7z M22.3,15.5c-1.7,0-3-1.3-3-3
			s1.3-3,3-3s3,1.3,3,3S23.9,15.5,22.3,15.5z"/>
	</g>
	<g id="Layer_1_copy_1_" class="st1">
		<path d="M22.3,18.4c-2.1,0-3.9,1.7-3.9,3.9s1.7,3.9,3.9,3.9s3.9-1.7,3.9-3.9S24.4,18.4,22.3,18.4z M22.3,25.2c-1.7,0-3-1.3-3-3
			s1.3-3,3-3s3,1.3,3,3C25.3,23.9,23.9,25.2,22.3,25.2z"/>
	</g>
	<g id="Layer_1_copy_2_" class="st1">
		<path d="M22.3,28c-2.1,0-3.9,1.7-3.9,3.9s1.7,3.9,3.9,3.9s3.9-1.7,3.9-3.9S24.4,28,22.3,28z M22.3,34.9c-1.7,0-3-1.3-3-3
			s1.3-3,3-3s3,1.3,3,3S23.9,34.9,22.3,34.9z"/>
	</g>
</g>
<g id="Layer_2">
	<polygon points="38.1,20.9 12.2,20.9 20.9,12.8 18.9,10.7 6.5,22.3 18.9,33.9 20.9,31.8 12.1,23.7 38.1,23.7 	"/>
</g>
</svg>
